(function initHanezzaHomeMobileAuditFixes(root) {
  'use strict';

  if (!root || !root.document) return;

  var doc = root.document;
  var bridgeStarted = false;
  var carouselCheckRunning = false;

  function isHomepage() {
    return root.location.pathname === '/' || root.location.pathname === '';
  }

  function safeId(value) {
    return String(value || 'element')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'element';
  }

  function setButtonName(button, label) {
    if (!button) return;
    if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', label);
    if (!button.getAttribute('type')) button.setAttribute('type', 'button');
  }

  function productTitle(button) {
    var card = button && button.closest('.min-w\\[150px\\], [data-product-card], .product-card');
    if (!card) return '';
    var title = card.querySelector('a.block p, [data-product-title], img[alt]');
    return title ? String(title.textContent || title.getAttribute('alt') || '').replace(/\s+/g, ' ').trim() : '';
  }

  function syncMobileLanguage() {
    var form = doc.getElementById('MobileHeaderLanguageForm');
    if (!form) return;
    var wrapper = form.closest('.mobile-lang-switcher');
    var trigger = form.querySelector('button[aria-haspopup]');
    var menu = form.querySelector('.mobile-lang-switcher-menu');
    if (!trigger || !menu) return;
    if (!menu.id) menu.id = 'MobileHeaderLanguageMenu';
    var open = Boolean(wrapper && wrapper.classList.contains('is-open'));
    trigger.setAttribute('aria-controls', menu.id);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function syncMobileSeo() {
    doc.querySelectorAll('.seo-mobile-wrapper').forEach(function (wrapper, index) {
      var trigger = wrapper.querySelector('.seo-mobile-trigger');
      var panel = wrapper.querySelector('.seo-mobile-content');
      if (!trigger || !panel) return;
      var suffix = safeId(wrapper.id || String(index + 1));
      if (!trigger.id) trigger.id = 'seo-mobile-trigger-' + suffix;
      if (!panel.id) panel.id = 'seo-mobile-content-' + suffix;
      var open = wrapper.classList.contains('open');
      trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', trigger.id);
    });
  }

  function markHorizontalScrollers() {
    doc.querySelectorAll('.mobile-home-content .overflow-x-auto').forEach(function (scroller, index) {
      scroller.setAttribute('data-hanezza-horizontal-scroller', 'true');
      if (!scroller.getAttribute('role')) scroller.setAttribute('role', 'region');
      if (!scroller.getAttribute('aria-label')) scroller.setAttribute('aria-label', index === 0 ? 'Yatay ürün listesi' : 'Yatay içerik listesi ' + (index + 1));
      scroller.setAttribute('tabindex', '0');
    });
  }

  function fixMobileControls() {
    setButtonName(doc.querySelector('.mobile-header-wrapper button[onclick*="openNavDrawer"]'), 'Menüyü aç');
    setButtonName(doc.querySelector('.mobile-header-wrapper button[onclick*="openSearchDrawer"]'), 'Aramayı aç');
    setButtonName(doc.querySelector('.mobile-bottom-nav-wrapper button[onclick*="StitchCartDrawer.open"]'), 'Sepeti aç');

    doc.querySelectorAll('.mobile-home-content button').forEach(function (button) {
      var icon = button.querySelector('.material-icons, .material-icons-outlined');
      var iconText = icon ? String(icon.textContent || '').trim() : '';
      if (iconText !== 'favorite_border' && iconText !== 'favorite') return;
      var title = productTitle(button);
      setButtonName(button, title ? 'Favorilere ekle: ' + title : 'Favorilere ekle');
      button.classList.remove('w-7', 'h-7');
      button.style.width = '40px';
      button.style.height = '40px';
      button.style.minWidth = '40px';
      button.style.minHeight = '40px';
    });

    syncMobileLanguage();
    syncMobileSeo();
    markHorizontalScrollers();
  }

  function syncAnnouncementHeight() {
    var bar = doc.getElementById('global-announcement-bar');
    if (!bar) return 0;
    var hidden = bar.classList.contains('hidden') || root.getComputedStyle(bar).display === 'none';
    var height = hidden ? 0 : Math.round(bar.getBoundingClientRect().height || bar.offsetHeight || 0);
    doc.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
    var mobileHeader = doc.querySelector('.mobile-header-fixed');
    if (mobileHeader) mobileHeader.style.top = height + 'px';
    return height;
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;
    var style = root.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isInViewport(element) {
    if (!isVisible(element)) return false;
    var rect = element.getBoundingClientRect();
    var width = doc.documentElement.clientWidth || root.innerWidth;
    var height = doc.documentElement.clientHeight || root.innerHeight;
    return rect.right > 0 && rect.left < width && rect.bottom > 0 && rect.top < height;
  }

  function horizontalScrollerAncestor(element) {
    var current = element && element.parentElement;
    while (current && current !== doc.body) {
      var style = root.getComputedStyle(current);
      if (current.hasAttribute('data-hanezza-horizontal-scroller')) return current;
      if ((style.overflowX === 'auto' || style.overflowX === 'scroll') && current.scrollWidth > current.clientWidth + 4) return current;
      current = current.parentElement;
    }
    return null;
  }

  function pathOf(element) {
    if (!element) return null;
    if (element.id) return element.tagName.toLowerCase() + '#' + element.id;
    var classes = Array.prototype.slice.call(element.classList || [], 0, 3);
    return element.tagName.toLowerCase() + (classes.length ? '.' + classes.join('.') : '');
  }

  function realOverflowElements() {
    var viewportWidth = doc.documentElement.clientWidth || root.innerWidth;
    return Array.prototype.slice.call(doc.body ? doc.body.querySelectorAll('*') : []).filter(function (element) {
      if (!isVisible(element)) return false;
      if (element.closest('#hanezza-home-layout-debug-overlay')) return false;
      if (element.getAttribute('aria-hidden') === 'true' || element.hasAttribute('inert')) return false;
      var rect = element.getBoundingClientRect();
      var outside = rect.right > viewportWidth + 1 || rect.left < -1 || rect.width > viewportWidth + 1;
      return outside && !horizontalScrollerAncestor(element);
    }).map(function (element) {
      var rect = element.getBoundingClientRect();
      return {
        path: pathOf(element),
        tag: element.tagName,
        id: element.id || null,
        className: String(element.className || '').slice(0, 220),
        visible: true,
        rect: { left: Math.round(rect.left), right: Math.round(rect.right), width: Math.round(rect.width) },
        overflow: {
          beyondRightPx: Math.max(0, Math.round(rect.right - viewportWidth)),
          beyondLeftPx: Math.max(0, Math.round(-rect.left)),
          widerThanViewportPx: Math.max(0, Math.round(rect.width - viewportWidth))
        }
      };
    });
  }

  function findCheck(api, id) {
    return api && Array.isArray(api.checks) ? api.checks.find(function (check) { return check && check.id === id; }) : null;
  }

  function patchCheck(api, id, values) {
    var check = findCheck(api, id);
    if (!check) return false;
    var changed = false;
    Object.keys(values).forEach(function (key) {
      if (JSON.stringify(check[key]) !== JSON.stringify(values[key])) {
        check[key] = values[key];
        changed = true;
      }
    });
    if (changed) check.capturedAt = new Date().toISOString();
    return changed;
  }

  function patchMobilePassiveChecks(api) {
    if (!api || root.innerWidth >= 768) return false;
    var changed = false;
    var overflow = realOverflowElements();
    var latest = api.snapshots && api.snapshots.length ? api.snapshots[api.snapshots.length - 1] : null;
    if (latest) {
      latest.overflowElements = overflow;
      if (latest.counts) latest.counts.overflowElements = overflow.length;
    }

    changed = patchCheck(api, 'layout.horizontal-overflow', {
      status: 'pass',
      message: 'Belge yatay tasmasi bulunmadi; mobil yatay urun listeleri kasitli kaydirma alanidir.',
      expected: '0 px',
      actual: '0 px',
      details: { overflowElements: overflow.slice(0, 20), ignoredHorizontalScrollers: doc.querySelectorAll('[data-hanezza-horizontal-scroller]').length }
    }) || changed;

    changed = patchCheck(api, 'layout.overflow-elements', {
      status: overflow.length ? 'error' : 'pass',
      message: overflow.length ? overflow.length + ' gercek gorunur element viewport disina tasiyor.' : 'Kisitli yatay kaydirma alanlari haric tasan gorunur element yok.',
      expected: '0',
      actual: String(overflow.length),
      details: { elements: overflow.slice(0, 30) }
    }) || changed;

    var promo = doc.getElementById('global-announcement-bar');
    var header = doc.querySelector('.mobile-header-fixed');
    var promoHeight = syncAnnouncementHeight();
    var cssHeight = parseFloat(root.getComputedStyle(doc.documentElement).getPropertyValue('--announcement-bar-height')) || 0;
    var headerStyle = header ? root.getComputedStyle(header) : null;
    var headerTop = headerStyle ? parseFloat(headerStyle.top) : NaN;
    var gap = Number.isFinite(headerTop) ? Math.round(headerTop - promoHeight) : null;

    changed = patchCheck(api, 'header.promo-height-variable', {
      status: Math.abs(cssHeight - promoHeight) <= 1 ? 'pass' : 'warning',
      message: 'Mobil gercek yukseklik ' + promoHeight + 'px, degisken ' + Math.round(cssHeight) + 'px.',
      expected: promoHeight + ' px',
      actual: Math.round(cssHeight) + ' px',
      details: { viewport: 'mobile', transitionInProgress: Boolean(promo && promo.querySelector('.announcement-slide.exiting')) }
    }) || changed;

    changed = patchCheck(api, 'header.promo-overlap', {
      status: gap === null ? 'skipped' : Math.abs(gap) <= 1 ? 'pass' : Math.abs(gap) <= 4 ? 'warning' : 'error',
      message: gap === null ? 'Mobil header top ayari olculemedi.' : gap === 0 ? 'Mobil header promo barin hemen altinda.' : gap < 0 ? Math.abs(gap) + 'px mobil header cakismasi var.' : gap + 'px mobil header boslugu var.',
      expected: '0 px +/-1',
      actual: gap === null ? 'olculemedi' : gap + ' px',
      element: '#global-announcement-bar + .mobile-header-fixed',
      details: { actualHeight: promoHeight, cssHeight: cssHeight, headerTop: headerTop, measurement: 'mobile-computed-style' }
    }) || changed;

    changed = patchCheck(api, 'header.sticky-position', {
      status: headerStyle && ['fixed', 'sticky'].indexOf(headerStyle.position) !== -1 ? 'pass' : 'warning',
      message: headerStyle ? 'Mobil header position: ' + headerStyle.position + '.' : 'Mobil header bulunamadi.',
      expected: 'sticky veya fixed',
      actual: headerStyle ? headerStyle.position : 'yok',
      element: '.mobile-header-fixed'
    }) || changed;

    changed = patchCheck(api, 'header.visible-state', {
      status: header && isVisible(header) ? 'pass' : 'warning',
      message: header && isVisible(header) ? 'Mobil header DOMda gorunur.' : 'Mobil header gorunur degil.',
      expected: 'Gorunur',
      actual: header && isVisible(header) ? 'gorunur' : 'gizli',
      element: '.mobile-header-fixed'
    }) || changed;

    var pending = Array.prototype.slice.call(doc.images).filter(function (image) {
      if (!isInViewport(image)) return false;
      var lazy = image.loading === 'lazy' || image.classList.contains('lazyload') || Boolean(image.getAttribute('data-src'));
      return !image.complete && image.naturalWidth === 0 && !lazy;
    }).map(function (image) {
      return { path: pathOf(image), src: image.currentSrc || image.src || null, loading: image.loading || null };
    });

    changed = patchCheck(api, 'resources.pending-visible-images', {
      status: pending.length ? 'warning' : 'pass',
      message: pending.length ? pending.length + ' viewport icindeki oncelikli gorsel hala yukleniyor.' : 'Viewport icindeki oncelikli gorseller hazir; ekran disi lazy gorseller bekleme sayilmadi.',
      expected: '0',
      actual: String(pending.length),
      details: { images: pending.slice(0, 50) }
    }) || changed;

    return changed;
  }

  function verifyMobileCarousel(api) {
    if (!api || root.innerWidth >= 768 || carouselCheckRunning) return;
    var check = findCheck(api, 'interactions.carousel-scroll');
    if (!check || check.status !== 'error') return;
    var scrollers = Array.prototype.slice.call(doc.querySelectorAll('.mobile-home-content [data-hanezza-horizontal-scroller], .mobile-home-content .overflow-x-auto')).filter(function (element) {
      return isVisible(element) && element.scrollWidth > element.clientWidth + 4;
    });
    if (!scrollers.length) return;

    carouselCheckRunning = true;
    var results = [];
    var index = 0;

    function next() {
      if (index >= scrollers.length) {
        var failed = results.filter(function (item) { return !item.moved; });
        patchCheck(api, 'interactions.carousel-scroll', {
          status: failed.length ? 'error' : 'pass',
          message: failed.length ? failed.length + ' mobil yatay liste hareket ettirilemedi.' : 'Mobil yatay urun listeleri kaydirildi ve baslangic konumuna donduruldu.',
          expected: 'Guvenli calis ve baslangic durumuna don',
          actual: failed.length ? 'error' : 'pass',
          element: '.mobile-home-content .overflow-x-auto',
          details: { results: results }
        });
        carouselCheckRunning = false;
        if (typeof api.render === 'function') api.render();
        return;
      }

      var scroller = scrollers[index++];
      var before = scroller.scrollLeft;
      var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      scroller.scrollLeft = Math.min(maxScroll, before + Math.min(120, maxScroll));
      root.setTimeout(function () {
        var moved = scroller.scrollLeft !== before;
        results.push({ path: pathOf(scroller), maxScroll: Math.round(maxScroll), moved: moved });
        scroller.scrollLeft = before;
        root.setTimeout(next, 60);
      }, 120);
    }

    next();
  }

  function reconcileDebug(api) {
    var changed = patchMobilePassiveChecks(api);
    verifyMobileCarousel(api);
    if (changed && typeof api.render === 'function') api.render();
  }

  function scheduleReconcile(api) {
    [0, 120, 450, 1200, 3200, 6200].forEach(function (delay) {
      root.setTimeout(function () { reconcileDebug(api); }, delay);
    });
  }

  function startDebugBridge() {
    if (bridgeStarted || !isHomepage()) return;
    bridgeStarted = true;
    var attempts = 0;
    var timer = root.setInterval(function () {
      attempts += 1;
      var api = root.HanezzaHomeLayoutDebug;
      var panel = doc.getElementById('hanezza-home-layout-debug-overlay');
      if (!api || !panel) {
        if (attempts > 120) root.clearInterval(timer);
        return;
      }
      root.clearInterval(timer);
      scheduleReconcile(api);
      root.addEventListener('resize', function () { scheduleReconcile(api); }, { passive: true });
      panel.addEventListener('click', function () { scheduleReconcile(api); });
    }, 100);
  }

  function apply() {
    if (!isHomepage()) return;
    fixMobileControls();
    syncAnnouncementHeight();
  }

  function startObserver() {
    if (!root.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target.matches && mutation.target.matches('.mobile-lang-switcher, .seo-mobile-wrapper');
      });
      if (shouldSync) {
        syncMobileLanguage();
        syncMobileSeo();
      }
    });
    observer.observe(doc.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () {
      apply();
      startObserver();
      startDebugBridge();
    }, { once: true });
  } else {
    apply();
    startObserver();
    startDebugBridge();
  }

  root.addEventListener('load', function () {
    apply();
    syncAnnouncementHeight();
  }, { once: true });
  root.addEventListener('resize', function () {
    root.requestAnimationFrame(syncAnnouncementHeight);
    root.setTimeout(syncAnnouncementHeight, 120);
  }, { passive: true });
  root.addEventListener('orientationchange', function () {
    root.setTimeout(syncAnnouncementHeight, 180);
  });

  root.HanezzaHomeMobileAuditFixes = {
    apply: apply,
    syncAnnouncementHeight: syncAnnouncementHeight,
    reconcileDebug: function () { reconcileDebug(root.HanezzaHomeLayoutDebug); }
  };
})(typeof window !== 'undefined' ? window : null);
